import api from './api';
import { ApiResponse, Class, ClassRequest, PageResponse } from '../types';

export const classService = {
  // 获取学校的所有年份列表
  getAcademicYears: async (schoolId: number): Promise<string[]> => {
    const response = await api.get<ApiResponse<string[]>>('/admin/classes/years', {
      params: { schoolId },
    });
    return response.data.data;
  },

  // 获取所有年级列表（从数据库已有班级中提取）
  getAllGrades: async (): Promise<string[]> => {
    const response = await api.get<ApiResponse<string[]>>('/admin/classes/grades');
    return response.data.data;
  },

  // 获取全局所有学年列表（不限学校）
  getAllAcademicYears: async (): Promise<string[]> => {
    const response = await api.get<ApiResponse<string[]>>('/admin/classes/years');
    return response.data.data;
  },

  // 获取学校某年的班级列表
  getClasses: async (params: {
    schoolId: number;
    year: string;
    page?: number;
    size?: number;
    sort?: string;
  }): Promise<PageResponse<Class>> => {
    const response = await api.get<ApiResponse<PageResponse<Class>>>('/admin/classes', {
      params: {
        schoolId: params.schoolId,
        year: params.year,
        page: params.page || 0,
        size: params.size || 20,
        sort: params.sort || 'sequence,asc',
      },
    });
    return response.data.data;
  },

  // 获取班级详情
  getClass: async (classId: string): Promise<Class> => {
    const response = await api.get<ApiResponse<Class>>(`/admin/classes/${classId}`);
    return response.data.data;
  },

  // 创建班级
  createClass: async (data: ClassRequest): Promise<Class> => {
    const response = await api.post<ApiResponse<Class>>('/admin/classes', data);
    return response.data.data;
  },

  // 更新班级
  updateClass: async (classId: string, data: ClassRequest): Promise<Class> => {
    const response = await api.put<ApiResponse<Class>>(`/admin/classes/${classId}`, data);
    return response.data.data;
  },

  // 删除班级
  deleteClass: async (classId: string): Promise<void> => {
    await api.delete(`/admin/classes/${classId}`);
  },

  // 批量创建班级
  batchCreate: async (data: BatchClassRequest): Promise<BatchClassResponse> => {
    const response = await api.post<ApiResponse<BatchClassResponse>>('/admin/classes/batch', data);
    return response.data.data;
  },
};

// ---- batch types ----
export interface BatchClassRequest {
  schoolId: number;
  academicYear: string;
  items: BatchClassItem[];
}

export interface BatchClassItem {
  grade?: string;
  // 模式 A
  namePattern?: string;
  startNum?: number;
  count?: number;
  // 模式 B
  names?: string[];
  description?: string;
}

export interface BatchClassResponse {
  created: number;
  skipped: number;
  failed: number;
  items: Array<{
    name: string;
    classId?: string;
    grade?: string;
    status: 'CREATED' | 'SKIPPED' | 'FAILED';
    message?: string;
  }>;
}
